import { Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";

export const AuditChip = ({ audit, role, author_type }) => {
    const theme = useTheme();
    
    // Support multiple ways to pass the role: audit.role, audit.author_type, role prop, author_type prop, or direct string
    const roleValue = role || author_type || audit?.role || audit?.author_type || (typeof audit === 'string' ? audit : null);
    
    const isAdmin = roleValue === "admin";
    const isAuditor = roleValue === "auditor";

    let bgColor, textColor;
    if (isAdmin) {
        bgColor = theme.customColors.status.info?.bg || "#1976d2";
        textColor = theme.customColors.status.info?.text || "#fff";
    } else if (isAuditor) {
        bgColor = theme.customColors.status.warning?.bg || "#ff9800";
        textColor = theme.customColors.status.warning?.text || "#fff";
    } else {
        bgColor = theme.palette.grey[300];
        textColor = theme.palette.text.primary;
    }

    const label = roleValue ? roleValue.charAt(0).toUpperCase() + roleValue.slice(1) : "Unknown";

    return (
        <Chip
            label={label}
            variant="filled"
            size="small"
            sx={{
                minWidth: "90px",
                height: "28px",
                fontWeight: 600,
                fontSize: "0.75rem",
                border: "none",
                borderRadius: 0,
                boxShadow: theme.customColors.shadow?.main || "none",
                transition: "all 0.2s ease",
                backgroundColor: bgColor,
                color: textColor,
            }}
        />
    );
}